$(document).ready(function () {
    // VARIABLES
    // let showMoreButtons = $('.show-more');

    // EVENTS
    $('body').on('click', '.js-close-popup', closePopup);
    $(document).on('click', '.js-add-to-cart', addToCart);
    // showMoreButtons.on('click', expandDeliveryAddress);																	// use delivery address in order
    // $('.js-submit-points,.js-submit-discount').on('click', submitCart1Form);
    // $('.js-quantity').on('change', updateResponsiveInput);

    // FUNCTIONS
    function closePopup(e) {																							// close popup on adding new cart item
        $('.mfp-close').trigger('click');
    }

    // function expandDeliveryAddress(e) {																					// open delivery address
    //
    //     e.preventDefault();
    //
    //     setDeliveryAddressSlider($(e.target), $(e.target).prev());
    // }

    function addToCart(e) {																								// ajax request - add new item, refresh header cart list

        e.preventDefault();

        let $that = $(this),
            $root = $that.closest('.js-cart-item'),
            addToCartUrl = $that.attr('data-add-url'),
            quantityElement = $root.find('.js-count'),
            quantity = quantityElement.length ? quantityElement.val() : 1,
            parameters = {
                id: $that.attr('data-id'),
                type: $root.find('.js-type').val(),
                quantity: quantity,
                _token: $('meta[name="csrf-token"]').attr('content')
            };

        $.ajax({
            url: addToCartUrl,
            type: "POST",
            data: parameters,
            success: function (response) {

                clearPopupOrFlashMessage();
                prepareDataToGTM(response, 'add_to_cart');

                if (response.error) {
                    $('body').append(response.popup);																	// Flash message
                } else {
                    // refreshCartList(response);
                    addQauntityCounter(response.quantity);

                    window.$.magnificPopup.open({																		// After updated popup will be opened
                        items: {
                            src: response.popup,
                            type: 'inline'
                        }
                    });
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    }

    function addQauntityCounter(quantity) {
        if ( quantity > 99 )
            $('.js-quantity').text('99+');
        else
            $('.js-quantity').text(quantity);
    }

    // function submitCart1Form(e) {
    //
    //     e.preventDefault();
    //
    //     let form = $('#js-cart-1');
    //     form.attr('action', $(this).attr('data-action'));
    //
    //     form.submit();
    // }

    // function updateResponsiveInput(e) {
    //
    //     let inputName = $(this).attr('name');
    //     let inputValue = $(this).val();
    //
    //     $('tbody').find(`input[name="${inputName}"]`).each((index, item) => {
    //         $(item).attr('value', inputValue)
    //     });
    // }

    // function refreshCartList(data) {																					// add new row to .cart-list or increment quantity
    //
    //     let cartList = $('header .cart-list');
    //
    //     if (cartList.length) {
    //
    //         let cartItemId = data.cartItemId,
    //             cartItemRows = Array.from(cartList.find('li[data-id]'));	// return true, if new cart item is not in header cart list
    //
    //         // if item is in cart list
    //         if (isItemInHeaderList(cartItemRows, cartItemId)) {
    //             // refresh product quantity
    //             cartList.find(`li[data-id=${cartItemId}]`).replaceWith(data.cartListItem);
    //         } else {
    //             // create new row in cart list - view cartListItem
    //             cartList.find('ul').append(data.cartListItem);
    //         }
    //         // set counter in header
    //         $('header .js-quantity').text(data.quantity);
    //         // set total price
    //         $('header .js-price').text(data.totalPrice);
    //     }
    // }
    //
    // function setDeliveryAddressSlider(deliveryButton, deliveryInput) {													// set delivery block - slide up or down
    //
    //     if (deliveryInput.val() == 1) {
    //         deliveryInput.val(0);
    //         deliveryButton.next().slideUp();
    //     } else {
    //         deliveryInput.val(1);
    //         deliveryButton.next().slideDown();
    //     }
    // }

    function clearPopupOrFlashMessage() {																				// clear popup nad flashmessage, if already exists
        let flashMessage = $('.js-alert');

        if (flashMessage.length) {
            flashMessage.remove();
        }
    }

    // function isItemInHeaderList(cartList, cartItemId) {																	// find cart item row in header cart list
    //
    //     return cartList.some(function (item) {
    //         return $(item).attr('data-id') == cartItemId;
    //     });
    // }

    // ON LOAD
    if ($('.js-alert').length)																							// remove flash message after 8 seconds
        setTimeout(() => {
            $('.js-alert').remove();
        }, 8000);


    // if (showMoreButtons.length) {																						// open/close slider "change delivery informations"
    //     // open delivery address sliders																				// by value in useDeliveryAddress input
    //     showMoreButtons.each((key, button) => {
    //
    //         let deliveryButton = $(button),
    //             deliveryInput = $(button).prev();
    //
    //         if (deliveryInput.val() === '1') {
    //             deliveryButton.next().slideDown();
    //         } else {
    //             deliveryButton.next().slideUp();
    //         }
    //     });
    // }

    $('.js-cart-confirm').on('click', function(e) {
        e.preventDefault();

        if ( $('#delivery2').prop('checked') && !$('.js-calculate-zip').find('.js-zip-code').val().length )
            alert($("section.cart").attr('data-text-calculate'));
        else
            $('.js-cart1-step-form').submit();
    });

    $('.js-calculate-zip').on('submit', function (e) {
        e.preventDefault();

        if ( $(this).find('.js-zip-code').val().length )
            $(this)[0].submit();
        else
            alert($("section.cart").attr('data-text-calculate'));
    });

    if ( $('.js-box-delivery').length ) {
        let cart1DeliveryForm      = $('.js-cart1-step-form'),
            cart1DeliveryFormInput = cart1DeliveryForm.find('.js-delivery');

        // Osobný odber id 1
        // const deliveryZipId1 = 1;
        const deliveryZipId2 = 'delivery2';

        $('.js-cart-delivery').on('change', function() {

            if ( $(this).attr('id') !== deliveryZipId2 ) {
                cart1DeliveryFormInput.val('');
                $('.js-calculate-zip').find('.js-zip-code')[0].selectize.clear(true);

                $.ajax({
                    url: $(this).attr('data-url'),
                    type: 'post',
                    success: function (response) {
                        location.reload();
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log(textStatus, errorThrown);
                    }
                });
            }
        });
    }

    $('.js-cart-delivery-reset').click(function (e){
       e.preventDefault();
       location.replace($(this).attr('data-url'));
    });

    //ODOSLANIE OBJ
    $('.js-submit-order').on('click', function (e) {
        e.preventDefault();
        $(this).hide();
        $('.js-submit-order-loader').show();
        $('#postCart4').submit();
    });

    function prepareDataToGTM(data, eventName) {
        let final_quantity = data.cartItem.requestData.quantity;
        let final_price = data.cartItem.productDb.prices_by_shop[0].price;

        if(data.cartItem.requestData.type == 'palette') {
            final_quantity = (data.cartItem.productDb.weight_palette/data.cartItem.productDb.weight_package) * data.cartItem.requestData.quantity;
            final_price = data.price_one_package;
        }

        const item = {
            item_id: data.cartItem.productDb.external_id,
            item_name: data.cartItem.productDb.name,
            affiliation: 'Eshop',
            coupon: '',
            discount: '',
            index: 1,
            item_category: data.cartItem.productDb.categories[0].name,
            item_list_id: '',
            item_list_name: '',
            item_variant: '',
            location_id: '',
            price: final_price,
            //quantity: data.cartItem.requestData.quantity
            quantity: final_quantity
        };

        const dataLayer = {
            'event': eventName,
            'ecommerce': {
                currency: "HUF",
                value: final_price * final_quantity,
                items: [item]
            }
        };

        window.dataLayer.push(dataLayer);
    }
});
